import { Component, Input, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { NotificationMessage, NotificationService, NotificationTypeEnum } from '@xpo-ltl/data-api';
import { XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoSnackBarStatus } from '@xpo-ltl/ngx-ltl-core/snack-bar/models/xpo-snack-bar-status.type';
import { SnackbarStatus } from '@enums/snackbar-status.enum';
import { DataValidationError } from '@xpo-ltl/sdk-common';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationComponent implements OnInit {
  message: string;
  show: boolean = false;

  @Input()
  showProgressSpinner = true;

  private snackBarRef;

  constructor(
    private notificationService: NotificationService,
    private zone: NgZone,
    private snackbar: XpoSnackBar
  ) {}

  ngOnInit() {
    this.notificationService.getSubscriber().subscribe((message: NotificationMessage) => {
      try {
        this.zone.run(() => {
          if (message.type === NotificationTypeEnum.ShowOverlay) {
            this.message = this.formatMessage(message.text);
            this.show = true;
          } else if (message.type === NotificationTypeEnum.HideOverlay) {
            this.show = false;
          } else if (message.type === NotificationTypeEnum.ShowSnackbar) {
            this.snackBarRef = this.snackbar.open({
              message: this.formatMessage(message.text),
              status: SnackbarStatus[message.status] as XpoSnackBarStatus,
              action:
                message != null && message.actionHandler != null && message.actionHandler.actionLabel() != null
                  ? message.actionHandler.actionLabel()
                  : null,
              matConfig: {
                duration: message.durationInMillis,
              },
            });

            if (message != null && message.actionHandler != null) {
              if (message.actionHandler.onAction != null) {
                this.snackBarRef.onAction().subscribe(message.actionHandler.onAction);
              }
              if (message.actionHandler.afterOpened != null) {
                this.snackBarRef.afterOpened().subscribe(message.actionHandler.afterOpened);
              }
              if (message.actionHandler.afterDismissed != null) {
                this.snackBarRef.afterDismissed().subscribe(message.actionHandler.afterDismissed);
              }
            }
          }
        });
      } catch (error) {
        // todo: log
      }
    });
  }

  private formatMessage(text: string | DataValidationError[]): string {
    if (typeof text === 'string') {
      return text;
    }
    // If it's an array of DataValidationError, join their messages
    return text.map((error) => error.message).join(', ');
  }
}
